// extracted by mini-css-extract-plugin
module.exports = {"root":"DataList_root__2uMBJ"};